import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import RegistrationForm from '../components/RegistrationForm';

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5">
      
      <div className="max-w-4xl mx-auto px-4 py-20">
        {/* Back Button */}
        <motion.button
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-primary hover:text-primary/80 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </motion.button>

        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary to-accent mb-4">
            Register Now
          </h1>
          <p className="text-muted-foreground">
            Join us at the Oman Drone Carnival for an unforgettable experience
          </p>
        </motion.div>

        {/* Registration Form */}
        <RegistrationForm />

        {/* Info Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-12 glass-effect border border-primary/10 p-8 rounded-lg"
        >
          <h2 className="text-2xl font-heading font-bold text-primary mb-6">Event Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">Entry Fee</h3>
              <p className="text-3xl font-bold text-primary">5 OMR</p>
              <p className="text-sm text-muted-foreground mt-2">Per person for all 3 days</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">What's Included</h3>
              <ul className="text-sm text-muted-foreground space-y-2">
                <li>• Access to all zones</li>
                <li>• Competition entry</li>
                <li>• Workshop access</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">Age Requirements</h3>
              <p className="text-sm text-muted-foreground">Open to all ages from 1 to 120 years old</p>
              <p className="text-xs text-muted-foreground mt-2">Minors must be accompanied by a guardian</p>
            </div>
          </div>
        </motion.div>
      </div>

    </div>
  );
};

export default Register;
